import '../scheduler.scss';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import ChannelByContent from '../channelByContent.js';
import { BuilderContentType } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/BuilderContentType';
import { CardContent } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/CardContent';
import './Schedule.scss';
import { CONTENT_TYPES } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/InputController';
import { GROWTH_SCHEDULER_ADD_CONTENT_CHOSEN, GROWTH_SCHEDULER_ADD_SCHEDULE, GROWTH_SCHEDULE_STEP_AUDIENCE_CONTINUE_BUTTON_CLICKED, } from '../../GrowthSegmentEvents';
import { SchedulerFeatures } from '../SchedulerFeatures';
var PURPOSES;
(function (PURPOSES) {
    PURPOSES["CONFIRMED_EVENT_UPDATE"] = "schedule.newPurposes.confirmedEventUpdate";
    PURPOSES["POST_PURCHASE_UPDATE"] = "schedule.newPurposes.postPurchaseUpdate";
    PURPOSES["ACCOUNT_UPDATE"] = "schedule.newPurposes.accountUpdate";
    PURPOSES["NON_PROMOTIONAL_SUBSCRIPTION"] = "schedule.newPurposes.nonPromotionalSubscription";
    PURPOSES["RECURRENT_NOTIFICATION_MESSAGES"] = "schedule.newPurposes.recurringNotification";
})(PURPOSES || (PURPOSES = {}));
export class RawContent {
    static $inject = ['type', 'content', 'metadata'];
    constructor(type, content, metadata) {
        this.type = type;
        this.content = content;
        this.metadata = metadata;
    }
}
const MESSAGE_PURPOSE_METADATA_KEY = '#messagePurpose';
const MESSENGER_SOURCE_KEY = 'messenger.source';
export class ScheduleController {
    static $inject = ['$scope', '$state', '$translate', '$timeout', 'BuilderContentService', 'DistributionListService', '$stateParams', 'MessageService', 'LoadingService', 'GrowthSegmentService', 'SegmentService', 'ChannelsService', 'application', 'BlipToastService', 'TranslateService'];
    constructor($scope, $state, $translate, $timeout, BuilderContentService, DistributionListService, $stateParams, MessageService, LoadingService, GrowthSegmentService, SegmentService, ChannelsService, application, BlipToastService, TranslateService) {
        'ngInject';
        this.$scope = $scope;
        this.$state = $state;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.BuilderContentService = BuilderContentService;
        this.DistributionListService = DistributionListService;
        this.$stateParams = $stateParams;
        this.MessageService = MessageService;
        this.LoadingService = LoadingService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.SegmentService = SegmentService;
        this.ChannelsService = ChannelsService;
        this.application = application;
        this.BlipToastService = BlipToastService;
        this.TranslateService = TranslateService;
        this.hasPurpose = false;
        this.impactEvaluation = '0';
        this.textModified = false;
        this.isRawContent = false;
        this.distributionLists = [];
        this.noContentChannels = [];
        this.isMedia = false;
        this.ChangeCheckSchedule = (event) => {
            if (event.detail?.checked) {
                this.sendOption = event.target?.id == 'send-now' ? 'now' : 'schedule';
                this.setSchedule();
            }
        };
        this.changePurpose = (event) => {
            this.purpose = event.detail?.value;
            this.hasPurpose = Boolean(!this.purpose);
        };
        this.selectDistributionList = (event) => {
            const selectedValue = event.detail?.value;
            this.schedule.message.to = selectedValue || '';
            this.changeImpact();
        };
        this.contentTypes = CONTENT_TYPES.map(type => ({
            label: type,
            value: type,
        }));
        this.addNewBlockData = {
            text: this.$translate.instant('schedule.rawContent.addType'),
        };
        this.sendersDistributionListIdentity = `${application.shortName}+senders@broadcast.msging.net`;
        this.setTotal();
        this.$init();
    }
    async $init() {
        this.GrowthSegmentService.setApplication(this.application);
        await this.ChannelsService.init(this.application);
        await this.loadTranslations();
        await this.loadDistributionLists();
        this.$stateParams.id ? await this.setForm() : this.resetForm();
        this.setTimeList();
        this.$scope.$watch('$ctrl.sendOption', newVal => {
            if (newVal === 'schedule') {
                this.hour = moment()
                    .add(1, 'hour')
                    .second(0)
                    .milliseconds(0)
                    .toDate();
                this.changeDate();
            }
        });
    }
    addNewState({ newOption: { label } }) {
        if (this.currentCard instanceof RawContent) {
            this.currentCard.type = label;
            this.contentTypes = [...this.contentTypes, { label, value: label }];
            this.contentTypes.sort();
        }
    }
    async setTimeList() {
        this.dateFormat =
            this.TranslateService.getCurrentLanguage() === 'en'
                ? 'MM/dd/yyyy'
                : 'dd/MM/yyyy';
        this.date = moment().format('L');
    }
    changeDate() {
        if (!this.hour) {
            return;
        }
        if (this.TranslateService.getCurrentLanguage() === 'pt') {
            const dateArr = this.date.split('/');
            const date2 = `${dateArr[1]}/${dateArr[0]}/${dateArr[2]}`;
            this.schedulerDate = moment(date2)
                .hour(this.hour.getHours())
                .minute(this.hour.getMinutes())
                .toDate();
        }
        else {
            this.schedulerDate = moment(this.date)
                .hour(this.hour.getHours())
                .minute(this.hour.getMinutes())
                .toDate();
        }
    }
    setActiveMenu(type, content = {}) {
        switch (type) {
            case 'text/plain':
                return BuilderContentType.Text;
            case 'application/vnd.lime.media-link+json':
                return BuilderContentType.Media;
            case 'application/vnd.lime.location+json':
                return BuilderContentType.sendLocation;
            case 'application/vnd.lime.input+json':
                return BuilderContentType.UserInput;
            case 'application/vnd.lime.collection+json':
                return BuilderContentType.DocumentSelect;
            case 'application/vnd.lime.select+json':
                return content.scope
                    ? BuilderContentType.SelectImmediate
                    : BuilderContentType.Select;
            case 'application/vnd.lime.web-link+json':
                return BuilderContentType.webLink;
            default:
                return BuilderContentType.RawContent;
        }
    }
    setContentStep() {
        const isEditing = document.querySelectorAll('.btn.saveIco') || [];
        if (isEditing.length > 0) {
            const finish = isEditing[1];
            finish.click();
        }
        this.trackSchedulerAddContentChosen();
    }
    trackSchedulerStepAudienceContinueButton() {
        this.SegmentService.createApplicationTrack({
            trackEvent: GROWTH_SCHEDULE_STEP_AUDIENCE_CONTINUE_BUTTON_CLICKED,
            application: this.application,
        });
    }
    async setForm() {
        try {
            const { message: { type, content, id, metadata, to }, when, name, } = await this.MessageService.getSchedule({
                id: this.$stateParams.id,
            });
            this.resetForm();
            this.currentCardType = this.setActiveMenu(type, content);
            this.schedule.message.to = to;
            this.schedule.name = name;
            this.schedule.message = {
                ...this.schedule.message,
                type,
                content,
                id,
            };
            this.purpose = metadata[MESSAGE_PURPOSE_METADATA_KEY];
            this.sendOption = 'schedule';
            setTimeout(() => {
                this.date = moment(when).format('L');
                this.hour = moment(when).toDate();
            });
            if (this.currentCard instanceof CardContent &&
                this.currentCardType !== 'raw-content') {
                this.currentCard.document = { type, content, id };
            }
            else {
                this.currentCard = new RawContent(type, content.content, content.metadata);
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    resetForm() {
        this.schedule = {
            name: this.$translate.instant('schedule.defaultTitle'),
            message: {
                id: uuid(),
                to: this.sendersDistributionListIdentity,
                type: '',
                content: '',
                metadata: '',
            },
            status: '',
            when: new Date(),
        };
        this.setCardType(BuilderContentType.Text);
        this.channels = [];
        this.purpose = '';
        this.sendOption = 'now';
        this.date = '';
        this.hour = undefined;
        this.setAllowedChannels(this.schedule.message.type);
    }
    async loadTranslations() {
        this.cardTranslations = {
            text: await this.$translate('builder-tabs-content.media.text'),
            quickReply: await this.$translate('builder-tabs-content.media.quickReply'),
            image: await this.$translate('builder-tabs-content.media.image'),
            carousel: await this.$translate('builder-tabs-content.media.carousel'),
            menu: await this.$translate('builder-tabs-content.media.menu'),
            audio: await this.$translate('builder-tabs-content.media.audio'),
            video: await this.$translate('builder-tabs-content.media.video'),
            document: await this.$translate('builder-tabs-content.media.document'),
            sendLocation: await this.$translate('builder-tabs-content.media.sendLocation'),
            askLocation: await this.$translate('builder-tabs-content.media.askLocation'),
            webLink: await this.$translate('builder-tabs-content.media.webLink'),
            RawContent: await this.$translate('builder-tabs-content.media.rawContent'),
        };
        const usablePurpose = PURPOSES;
        const isEnableRecurrentNotificationMessages = await SchedulerFeatures.isEnableRecurrentNotificationMessages();
        this.purposeOptions = Object.keys(usablePurpose).map(p => {
            if (usablePurpose[p] != PURPOSES.RECURRENT_NOTIFICATION_MESSAGES ||
                (usablePurpose[p] == PURPOSES.RECURRENT_NOTIFICATION_MESSAGES && isEnableRecurrentNotificationMessages)) {
                return ({
                    value: p,
                    label: this.$translate.instant(usablePurpose[p]),
                });
            }
        });
    }
    async setCardContent() {
        try {
            if (this.currentCard instanceof CardContent) {
                this.schedule.message.content =
                    typeof this.currentCard.document.content === 'object'
                        ? {
                            ...this.currentCard.document.content,
                        }
                        : this.currentCard.document.content;
            }
            else {
                const { content, metadata, type } = this.currentCard;
                this.schedule.message = {
                    ...this.schedule.message,
                    type,
                    metadata: {
                        ...metadata,
                        ...this.schedule.message.metadata,
                    },
                    content: type.endsWith('json')
                        ? JSON.parse(content)
                        : content,
                };
            }
        }
        catch (error) {
            console.error(error instanceof SyntaxError, error);
            if (error instanceof SyntaxError) {
                throw new Error('invalidJSON');
            }
            else {
                throw new Error('setCard');
            }
        }
    }
    checkEdition() {
        return true;
    }
    async scheduleBroadcast() {
        try {
            this.setSchedule(); //Work with moment.js to send correctly
            this.setCardContent();
            this.validateAudience();
            this.validateScheduling();
            this.schedule.message.metadata = {};
            if (this.purpose == 'PURPOSES.RECURRENT_NOTIFICATION_MESSAGES') {
                this.schedule.message.metadata[MESSENGER_SOURCE_KEY] = this.purpose.toLowerCase().replace('-', '_');
            }
            else {
                this.schedule.message.metadata = {
                    [MESSAGE_PURPOSE_METADATA_KEY]: this.purpose,
                };
            }
            this.LoadingService.startLoading();
            await this.MessageService.setSchedule(this.schedule);
            const sucessMsg = await this.$translate('schedule.scheduleCreated');
            this.trackSchedulerAddSchedule();
            this.BlipToastService.show('success', {
                msg: sucessMsg,
            });
            this.$state.go('auth.application.detail.growth.scheduler');
        }
        catch (err) {
            this.handleBroadcastError(err);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async handleBroadcastError(err) {
        let errorMsg, title, msg;
        switch (err.message) {
            case 'noPurpose':
                console.error('Select a purpose for the broadcast');
                [title, msg] = (await this.$translate('schedule.errors.noPurpose')).split('</br>');
                this.hasPurpose = true;
                this.BlipToastService.show('danger', {
                    title,
                    msg,
                });
                break;
            case 'noDistList':
                console.error('No distribution list');
                errorMsg = await this.$translate('schedule.errors.noDistList');
                this.BlipToastService.show('danger', {
                    msg: errorMsg,
                });
                break;
            case 'datePassed':
                console.error('Scheduled date already passed');
                errorMsg = await this.$translate('schedule.errors.datePassed');
                this.BlipToastService.show('danger', {
                    msg: errorMsg,
                });
                break;
            case 'invalidJSON':
                console.error('Invalid content');
                errorMsg = await this.$translate('schedule.errors.invalidContent');
                this.BlipToastService.show('danger', {
                    msg: errorMsg,
                });
                break;
            default:
                console.error(err);
                errorMsg = await this.$translate('utils.errorMsg.6');
                this.BlipToastService.show('danger', {
                    msg: errorMsg,
                });
                break;
        }
    }
    setSchedule() {
        if (this.sendOption === 'now') {
            this.schedule.when = new Date();
        }
        else {
            this.schedule.when = this.schedulerDate;
        }
    }
    validateAudience() {
        if (!this.schedule.message.to) {
            throw new Error('noDistList');
        }
    }
    validateScheduling() {
        if (!this.purpose) {
            throw new Error('noPurpose');
        }
        if (this.sendOption !== 'now' &&
            this.schedule.when < moment().toDate()) {
            throw new Error('datePassed');
        }
    }
    async setTotal() {
        const { total, } = await this.DistributionListService.getDistributionListRecipient(this.sendersDistributionListIdentity);
        this.impactTotal = total || 0;
    }
    async changeImpact() {
        const { total, } = await this.DistributionListService.getDistributionListRecipient(this.schedule.message.to);
        this.impactEvaluation = total || 0;
    }
    async loadDistributionLists() {
        try {
            this.sendersDistributionListIdentity = `${this.application.shortName}+senders@broadcast.msging.net`;
            const ActiveCampaignDistributionListIdentity = 'activecampaign:';
            this.distributionLists.push({
                label: this.$translate.instant('modules.application.detail.growth.scheduler.allContacts'),
                value: this.sendersDistributionListIdentity,
            });
            const { total, } = await this.DistributionListService.getDistributionListRecipient(this.sendersDistributionListIdentity);
            this.impactEvaluation = total;
            const { items: distributionLists, } = await this.DistributionListService.getDistributionLists();
            if (distributionLists) {
                this.distributionLists = [
                    ...this.distributionLists,
                    ...distributionLists
                        .filter(identity => identity !=
                        this.sendersDistributionListIdentity && !identity.includes(ActiveCampaignDistributionListIdentity))
                        .map(identity => ({
                        label: identity.split('@')[0].split('.')[0],
                        value: identity,
                    })),
                ];
            }
        }
        catch (err) {
            console.error(err);
        }
    }
    getCardTranslation(type) {
        switch (type) {
            case BuilderContentType.SelectImmediate:
                return this.cardTranslations.quickReply;
            case BuilderContentType.Media:
                return this.cardTranslations.image;
            case BuilderContentType.DocumentSelect:
                return this.cardTranslations.carousel;
            case BuilderContentType.Select:
                return this.cardTranslations.menu;
            case BuilderContentType.MediaAudio:
                return this.cardTranslations.audio;
            case BuilderContentType.MediaVideo:
                return this.cardTranslations.video;
            case BuilderContentType.MediaDocument:
                return this.cardTranslations.document;
            case BuilderContentType.sendLocation:
                return this.cardTranslations.sendLocation;
            case BuilderContentType.askLocation:
                return this.cardTranslations.askLocation;
            case BuilderContentType.webLink:
                return this.cardTranslations.webLink;
            case BuilderContentType.RawContent:
                return this.cardTranslations.RawContent;
            case BuilderContentType.Text:
            default:
                return this.cardTranslations.text;
        }
    }
    setCardType(type) {
        this.textModified = false;
        this.currentCardType = type;
        this.currentCardName = this.getCardTranslation(this.currentCardType);
        if (this.currentCardType === 'raw-content') {
            this.isRawContent = true;
        }
        else {
            this.isRawContent = false;
        }
        const contentTemplate = this.BuilderContentService.getContentTemplate(type);
        const document = {
            ...contentTemplate,
            id: this.schedule.message.id,
        };
        this.currentCard =
            this.currentCardType !== 'raw-content'
                ? CardContent.create(document, 'middle', true, false, document => this.$timeout(() => this.saved(document)), undefined, undefined, true)
                : new RawContent('', '', undefined); // { type: '', content: '', metadata: undefined };
        this.schedule.message.type = contentTemplate.type;
        this.schedule.message.content = contentTemplate.content;
        this.setAllowedChannels(this.schedule.message.type);
    }
    saved(document) {
        if (!document || !document.type) {
            this.textModified = false;
            return false;
        }
        this.textModified = true;
        switch (document.type) {
            case 'text/plain':
                if (document.content === 'Some text') {
                    this.textModified = false;
                }
                break;
            case 'application/vnd.lime.select+json':
                if (document.content.text === 'Select text' ||
                    (document.content.options.length == 2 &&
                        (document.content.options[0].text === 'First option' ||
                            document.content.options[1].text ===
                                'Second option'))) {
                    this.textModified = false;
                }
                break;
            case 'application/vnd.lime.media-link+json':
                if ((document.content.type.startsWith('image/') &&
                    (document.content.title === 'Media link title' ||
                        document.content.text === 'Media link subtitle')) ||
                    (document.content.type.startsWith('audio/') &&
                        document.content.uri ===
                            'https://blip-community.s3-sa-east-1.amazonaws.com/007.mp3') ||
                    (document.content.type.startsWith('video/') &&
                        document.content.uri ===
                            'http://techslides.com/demos/sample-videos/small.mp4') ||
                    (document.content.type.startsWith('application/') &&
                        (document.content.title === 'pdf_open_parameters.pdf' ||
                            document.content.uri ===
                                'https://blip-community.s3-sa-east-1.amazonaws.com/documento-padrao-blip.pdf'))) {
                    this.textModified = false;
                }
                break;
            case 'application/vnd.lime.collection+json':
                if (document.content.items.length == 2 &&
                    (document.content.items[0].header.value.title ===
                        'First title' ||
                        document.content.items[0].header.value.text ===
                            'First subtitle' ||
                        document.content.items[1].header.value.title ===
                            'Second title' ||
                        document.content.items[1].header.value.text ===
                            'Second subtitle')) {
                    this.textModified = false;
                }
                break;
            case 'application/vnd.lime.select+json':
                if (document.content.text === 'Select text' ||
                    (document.content.options.length == 3 &&
                        (document.content.options[0].text === 'First option' ||
                            document.content.options[1].text ===
                                'Second option' ||
                            document.content.options[2].text ===
                                'Third option'))) {
                    this.textModified = false;
                }
                break;
            case 'application/vnd.lime.location+json':
                if (document.content.text === "Take's office" &&
                    (document.content.latitude === -19.918899 ||
                        document.content.longitude === -43.959275)) {
                    this.textModified = false;
                }
                break;
            case 'application/vnd.lime.input+json':
                if (document.content.validation.type ===
                    'application/vnd.lime.location+json' &&
                    document.content.label.value ===
                        'Please share your location') {
                    this.textModified = false;
                }
                break;
            case 'application/vnd.lime.web-link+json':
                if (document.content.title === 'Weblink title' ||
                    document.content.text === 'Weblink subtitle' ||
                    document.content.uri ===
                        'http://limeprotocol.org/content-types.html#web-link') {
                    this.textModified = false;
                }
                break;
            default:
                this.textModified = false;
                break;
        }
        return true;
    }
    setAllowedChannels(mimeType) {
        if (!ChannelByContent[mimeType]) {
            console.error('Error: invalid MIME type', mimeType);
            return;
        }
        this.currentMimeType = mimeType;
        if (mimeType === 'application/vnd.lime.media-link+json') {
            this.channels =
                ChannelByContent[mimeType][this.currentCardType] || [];
            this.linkOnlyChannels();
            this.isMedia = true;
        }
        else {
            this.channels = ChannelByContent[mimeType];
            this.textOnlyChannels();
            this.isMedia = false;
        }
    }
    linkOnlyChannels() {
        this.noContentChannels = ChannelByContent['text/plain'].reduce((array, curr) => {
            if (this.channels &&
                this.channels.find(channel => channel.name === curr.name)) {
                return array;
            }
            return [...array, curr];
        }, []);
    }
    textOnlyChannels() {
        this.noContentChannels = ChannelByContent['text/plain'].reduce((array, curr) => {
            if (this.channels &&
                this.channels.find(channel => channel.name === curr.name)) {
                return array;
            }
            return [...array, curr];
        }, []);
    }
    // Segment
    trackSchedulerAddSchedule() {
        const SendType = this.sendOption == 'now' ? 'SendNow' : 'ScheduleSend';
        if (this.sendOption == 'now') {
            this.schedulerDate = new Date();
            this.hour = new Date();
        }
        const messagetype = this.getMessagetype();
        this.SegmentService.createApplicationTrack({
            trackEvent: GROWTH_SCHEDULER_ADD_SCHEDULE,
            application: this.application,
            payload: {
                MessageType: messagetype,
                SendType: SendType,
                ScheduleDate: this.addZero(this.schedulerDate.getFullYear()) + '-' + this.addZero(this.schedulerDate.getMonth() + 1) + '-' + this.addZero(this.schedulerDate.getDate()),
                ScheduleTime: this.addZero(this.hour.getHours()) + ':' + this.addZero(this.hour.getMinutes()) + ':' + this.addZero(this.hour.getSeconds()),
                ContactListName: this.schedule.message.to,
            },
        });
    }
    trackSchedulerAddContentChosen() {
        this.GrowthSegmentService.trackEvent(GROWTH_SCHEDULER_ADD_CONTENT_CHOSEN, {
            ContentType: this.schedule.message.type,
        });
    }
    addZero(nbr) {
        return nbr > 9 ? nbr : ('0' + nbr);
    }
    getMessagetype() {
        switch (this.purpose) {
            case 'PURPOSES.RECURRENT_NOTIFICATION_MESSAGES':
                return 'RecurringNotifications';
            case 'PURPOSES.ACCOUNT_UPDATE':
                return 'AccountNotification';
            case 'PURPOSES.CONFIRMED_EVENT_UPDATE':
                return 'EventUpdate';
            case 'PURPOSES.NON_PROMOTIONAL_SUBSCRIPTION':
                return 'Non-promotionalContent';
            case 'PURPOSES.POST_PURCHASE_UPDATE':
                return 'AfterSales';
        }
        return '';
    }
}
